import React from "react"
import Link from "next/link"
import { Col, Row, Typography } from "antd"
import { BlockHalf, HeroTextBlock } from "./IndexHero"

export const Bubbles = ({ mappedBubbles }: Props) => {
  return mappedBubbles?.length > 0 ? (
    <BlockHalf>
      <Row gutter={[10, 10]}>
        {mappedBubbles.map((b) => (
          <Col key={b.title} xs={24 / 2} md={24 / 3}>
            <HeroTextBlock clickable={!!b.link}>
              {b.link ? (
                <Link href={b.link} title={b.title}>
                  <Typography.Title level={4}>{b.title}</Typography.Title>
                </Link>
              ) : (
                <>
                  <Typography.Title level={4}>{b.title}</Typography.Title>
                </>
              )}
            </HeroTextBlock>
          </Col>
        ))}
      </Row>
    </BlockHalf>
  ) : null
}

interface Props {
  mappedBubbles: Bubble[]
}

export interface Bubble {
  title: string
  text: React.ReactNode
  link?: string
}
